import api from '@/api';
import apiV2 from '@/api/v2';
export const getStructuresList = async (params) => {
    const { data } = await apiV2.get('structures', {
        params,
    });
    return data;
};
export const getStructuresListOld = async (params) => {
    const { data } = await api.get('structures', {
        params,
    });
    return data;
};
export const getCentralCostList = async (params) => {
    const { data } = await apiV2.get('central-costs', {
        params,
    });
    return data;
};
export const getRootStructure = async (brandId) => {
    const { results } = await getStructuresListOld({ brandId, parentId: 'null' });
    return results[0];
};
export const updateStructure = async (structureId, payload) => {
    const { data } = await api.patch(`structures/${structureId}`, payload);
    return data;
};
export const setStructureCentralCostBudget = async (structureId, centralCostId, payload) => {
    const { data } = await apiV2.post(`structures/${structureId}/central-cost/${centralCostId}/budget`, payload);
    return data;
};
export const getStructuresLevels = async (params) => {
    const { data } = await api.get(`structures/levels`, { params });
    return data;
};
